<template>
  <div
    class="asc-maintenance-grid-wrapper--container"
    data-automation-id="wrapper_maintenance_grid"
  >
    <asc-maintenance-grid
      :values="values"
      :on-open="onOpen"
      :export-button-visible="exportButtonVisible"
      :maintenance-export-table-grid-permission="
        maintenanceExportTableGridPermission
      "
      :maintenance-grid-permission="maintenanceGridPermission"
      :internal-user="internalUser"
      :grid-columns="gridColumns"
      :grid-filters="gridFilters"
      :grid-height="gridHeight"
      :on-mx-rec-alerts-export="onMxRecAlertsExport"
      :on-add-manual-mx-rec="onAddManualMxRec"
      :export-menu-items="exportMenuItems"
      :persistent-grid-id="persistentGridId"
      :has-user-airline-agreement="hasUserAirlineAgreement"
      v-on="$listeners"
    ></asc-maintenance-grid>
  </div>
</template>

<script>
import AscMaintenanceGrid from '@/components/molecules/AscMaintenanceGrid'

import { AscGridPropsMixin, AscRangeDatePickerMixin } from '@/components/mixins'

export default {
  name: 'AscMaintenanceGridWrapper',

  components: {
    AscMaintenanceGrid,
  },

  mixins: [AscGridPropsMixin, AscRangeDatePickerMixin],

  props: {
    onMxRecAlertsExport: {
      type: Function,
      default: () => {},
    },
    exportMenuItems: {
      type: Array,
      default: () => [],
    },
    onAddManualMxRec: {
      type: Function,
      default: () => {},
    },

    maintenanceExportTableGridPermission: {
      type: Boolean,
      default: false,
    },
    maintenanceGridPermission: {
      type: Boolean,
      default: false,
    },
    gridHeight: {
      type: String,
      default: 'lg',
    },
    persistentGridId: {
      type: String,
      default: '',
    },
    hasUserAirlineAgreement: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      selectedIssues: [],
    }
  },
}
</script>
